export default __webpack_public_path__ + "static/media/tom.e8ec5384.png";